import {Component, Prop, Vue} from 'vue-property-decorator';
import {HTTP} from "@/utils/httpCommonUtil";
import {getRestParamErrorMessage, getRestResponseErrorMessage} from "@/utils/serverErrorMessageUtil";
import {Writeable} from "@/interfaces/Writeable";
import {convertDateStringToUTCDate} from "@/utils/dateUtil";

@Component
export default class CrudMixin extends Vue {

  @Prop({type: [String], required: true})
  protected entityName!: string;

  @Prop({type: Number, required: false})
  protected maxItems!: number;

  protected loadingCounter = 0;
  protected items = [] as any;

  public async getItems() {
    this.loadingCounter++;
    try {
      const response = await HTTP.get(this.getFetchUrl());
      const items = response.data.data;
      items.forEach((item: any) => {
        item.isEditing = false;
        item.isUpdating = false;
        item.isNew = false;
        this.getFieldNames().forEach(fieldName => {
          item[fieldName + "ErrorMessage"] = '';
        });
        this.getStringDateFields().forEach(dateFieldName => {
          if (item[dateFieldName]) {
            item[dateFieldName] = convertDateStringToUTCDate(item[dateFieldName]);
          }
        });
      });
      this.items = items;
    } catch (error) {
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error',
        text: `An error occurred getting ${this.entityName} data.`,
        duration: 5000
      });
    } finally {
      this.loadingCounter--;
    }
  }

  public toggleEdit(item: Writeable) {
    const toggle = !item.isEditing;
    this.cleanupOtherCards(); // sets all isEdit to false
    item.isEditing = toggle;
  }

  public addNewItem() {
    this.cleanupOtherCards();
    const item = this.getNewBlankItemWithDefaultValues();
    item.id = +('-' + new Date().getTime()),
    item.isEditing = true;
    item.isUpdating = false;
    item.isNew = true;
    this.getFieldNames().forEach(fieldName => {
      item[fieldName + "ErrorMessage"] = '';
    });
    this.items.push(item);
  }

  public canAddItem() {
    if (!this.maxItems || this.items.length < this.maxItems) {
      return this.items.every((item: Writeable) => {
        return !item.isNew;
      });
    }
  }

  public async cancelChanges(item: Writeable) {
    await this.getItems();
  }

  public async writeItem(item: Writeable) {
    item.isUpdating = true;
    try {
      item.id < 0
        ? await HTTP.post(this.getWriteUrl(), item)
        : await HTTP.put(`${this.getWriteUrl()}/${item.id}`,item);
      await this.getItems();
    } catch (error) {
      item.isUpdating = false;
      this.getFieldNames().forEach(fieldName => {
        item[`${fieldName}ErrorMessage`] = getRestParamErrorMessage(error, fieldName);
      });
      const shouldIgnoreGeneralError = this.getFieldNames().some(fieldName => {
        return item[`${fieldName}ErrorMessage`].length;
      });
      if (!shouldIgnoreGeneralError) {
        let generalError = getRestResponseErrorMessage(error);
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Updating',
          text: generalError ? generalError : `An error occurred saving the ${this.entityName}.`,
        });
      }

    }
  }

  public async deleteItem(item: Writeable) {
    try {
      await HTTP.delete(`${this.getWriteUrl()}/${item.id}`);
      await this.getItems();
    } catch(error) {
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error',
        text: `An error occurred deleting the ${this.entityName}.`,
        duration: 5000
      });
    }
  }

  protected getNewBlankItemWithDefaultValues() {
    return {} as Writeable;
  }

  protected getFetchUrl() : string {
    return '';
  }

  protected getWriteUrl() : string {
    return '';
  }

  protected getFieldNames() : string[] {
    return [];
  }

  protected getStringDateFields() : string[] {
    return [];
  }

  private cleanupOtherCards() {
    let indexesToDelete: any = [];
    this.items.forEach((item: Writeable, index: number) => {
      if (item.isNew) {
        indexesToDelete.push(index);
      }
      item.isEditing = false;
    });
    indexesToDelete.forEach((indx: number) => {
      this.items.splice(indx, 1);
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/mixins/CrudMixin.ts